import React from 'react';

var IconBlock = function (_a) {
    var iconType = _a.iconType;
    return React.createElement("i", { className: "ui-lib-".concat(iconType) });
};

export { IconBlock };
